import { Barangay, PrefixOption } from '../../types';
import {
  Box,
  Typography
} from '@mui/material';

import PrecinctVotersListEntry from './PrecinctVotersListEntry';
import React from 'react';

interface PrintablePrecinctVotersReportProps {
  barangay: Barangay;
  precincts: string[];
  prefixOption?: PrefixOption;
}

const PrintablePrecinctVotersReport: React.FC<PrintablePrecinctVotersReportProps> = ({ 
  barangay, 
  precincts = [],
  prefixOption = 'numbers'
}) => {
  return (
    <Box sx={{ 
      p: 2, 
      '@media print': { 
        margin: 0, 
        padding: '10mm', 
        height: '100%' 
      } 
    }}>
      {precincts.map(precinct => (
        <>
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Typography variant="h6" gutterBottom>
              {barangay.city_municipality.toUpperCase()}, BARANGAY {barangay.barangay.toUpperCase()}, PRECINCT {precinct}
            </Typography>
          </Box>
          <Box sx={{ columnCount: 3, columnGap: '20px', mb: 4 }}>
            <PrecinctVotersListEntry 
              barangay={barangay} 
              precinct={precinct} 
              prefixOption={prefixOption}
            />
          </Box>
        </>
      ))}
    </Box>
  );
};

export default PrintablePrecinctVotersReport;
